export class UcdpSubmissionModel {
	lastCUScore: string;
    lastLCAScore: string;
    lastDocFileId: string;
	docFileIdEAD: string;
	docFileIdUCDP: string;
	canSubmitEAD: boolean;
	canSubmitUCDP: boolean;
	canSubmitEadMessages: string[];
	canSubmitUcdpMessages: string[];
	requestedAction: string;
    data: UcdpSumissionDataModel[];

	constructor() {
		this.lastCUScore = '';
		this.lastLCAScore = '';
		this.lastDocFileId = '';
		this.docFileIdEAD = '';
		this.docFileIdUCDP = '';
		this.canSubmitEAD = false;
		this.canSubmitUCDP = false;
		this.canSubmitEadMessages = [];
		this.canSubmitUcdpMessages = [];
		this.requestedAction = '';
		this.data = [];
	}
}

export class UcdpSumissionDataModel {
	submissionId?: string;
	docFileId: string;
	requested: string;
	responded: string;
	transactionId: string;
	transactionStatus: string;
	transactionMessage: string;
	transactionResultStatus?: string;
	transactionResultStatusDescription?: string;
	transactionResultStatusMessage?: string;
	service: string;
	passed: boolean;
	hardStops: number | null;
	findings: number | null;
	providers: UcdpSubmisionDataProvidersModel[];

	constructor() {
		this.submissionId = undefined;
	}
}

export class UcdpSubmisionDataProvidersModel {
	documentFormat?: string;
	provider: string;
	passed: boolean;
	score: string;
	documentUrl: string;
}

export class UcdpFindingsModel {
	data: UcdpFindingsDataModel[];
}

export class UcdpFindingsDataModel {
	id: string;
	rule: string;
	description: string;
	responseDate: string;
}

export class UcdpHardstopsModel {
	data: UcdpHardstopsDataModel[];
}

export class UcdpHardstopsDataModel {
	id: string;
	hardstop: string;
	description: string;
	canOverride: boolean;
	autoOverride: boolean;
	overrideCode: string;
	overrideComment: string;
	overrideSubmitted: boolean;
	submitted: string;
}

export class UcdpHardStopsCodesModel {
	reasonCode: string;
	commentRequired: boolean;
	description: string;
}
